<template>
  <div>
    <template v-if="!valueArray.length">
      -
    </template>
    <transition-group
      name="list"
      tag="ul">
      <li
        v-for="(valueItem, valueIndex) in valueArray"
        :key="`${valueIndex}-${valueItem}`"
        class="text-left">
        <ul>{{ valueItem }}</ul>
      </li>
    </transition-group>
  </div>
</template>
<script>
export default {
  name: 'settingEmailsView',
  computed: {
    valueArray() {
      if (!this.value) {
        return []
      }
      return this.value.split (',')
    }
  },
  props: {
    value: {
      type: String
    }
  },
}
</script>
